export default {
  "地区选择": "Regional selection",
  "请补全服务地区信息": "Please complete the service area information",
  "请输入需要识别的文本": "Please enter the text you want to identify",
  "请选择": "Please select",
  "识别": "recognize",
  "粘贴文本至此处，可自动识别地址信息": "Paste the text here to automatically identify the address information"
}
